module.exports = __webpack_public_path__ + "media/ru.0cacf46e.svg";